import { z } from "zod"

export const loginSchema = z.object({
  username: z.string().min(1, "Wymagana nazwa użytkownika"),
  password: z.string().min(1, "Wymagane hasło"),
})

export type LoginFormValues = z.infer<typeof loginSchema>

// Field name "otp_code" celowo snake_case zamiast camelCase - 1Password / Bitwarden / browser
// password managers heuristically detect autofill targets by name attribute. Snake_case + autoComplete
// "one-time-code" + pattern numeric to konwencja halocrm/tourpilot.
export const otpStepSchema = z.object({
  otp_code: z
    .string()
    .min(6, "Kod 2FA musi mieć 6 cyfr")
    .max(6, "Kod 2FA musi mieć 6 cyfr")
    .regex(/^\d{6}$/, "Kod 2FA to 6 cyfr"),
})

export type OtpFormValues = z.infer<typeof otpStepSchema>
